// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.EventsControlPage {
  min-height: 100vh;
  background: #f5f5f5;
  padding-left: 280px;
  width: 100%;
  box-sizing: border-box;
}
@media (max-width: 800px) {
  .EventsControlPage {
    padding-left: 0;
  }
}

.event-filters {
  display: flex;
  gap: 16px;
  margin-bottom: 24px;
  flex-wrap: wrap;
  align-items: center;
}
@media (max-width: 600px) {
  .event-filters {
    flex-direction: column;
    align-items: stretch;
  }
}

.event-grid {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(300px, 1fr));
  gap: 20px;
  margin-top: 20px;
}
@media (max-width: 768px) {
  .event-grid {
    grid-template-columns: 1fr;
  }
}`, "",{"version":3,"sources":["webpack://./src/routes/pages/EventsControlPage/EventsControlPage.scss"],"names":[],"mappings":"AAAA;EACE,iBAAA;EACA,mBAAA;EACA,mBAAA;EACA,WAAA;EACA,sBAAA;AACF;AACE;EAPF;IAQI,eAAA;EAEF;AACF;;AAEA;EACE,aAAA;EACA,SAAA;EACA,mBAAA;EACA,eAAA;EACA,mBAAA;AACF;AACE;EAPF;IAQI,sBAAA;IACA,oBAAA;EAEF;AACF;;AACA;EACE,aAAA;EACA,4DAAA;EACA,SAAA;EACA,gBAAA;AAEF;AAAE;EANF;IAOI,0BAAA;EAGF;AACF","sourcesContent":[".EventsControlPage {\n  min-height: 100vh;\n  background: #f5f5f5;\n  padding-left: 280px; // Ширина сайдбара\n  width: 100%;\n  box-sizing: border-box;\n\n  @media (max-width: 800px) {\n    padding-left: 0;\n  }\n}\n\n// Дополнительные стили для компонентов, если нужно\n.event-filters {\n  display: flex;\n  gap: 16px;\n  margin-bottom: 24px;\n  flex-wrap: wrap;\n  align-items: center;\n\n  @media (max-width: 600px) {\n    flex-direction: column;\n    align-items: stretch;\n  }\n}\n\n.event-grid {\n  display: grid;\n  grid-template-columns: repeat(auto-fill, minmax(300px, 1fr));\n  gap: 20px;\n  margin-top: 20px;\n\n  @media (max-width: 768px) {\n    grid-template-columns: 1fr;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"EventsControlPage": `EventsControlPage`,
	"event-filters": `event-filters`,
	"event-grid": `event-grid`
};
export default ___CSS_LOADER_EXPORT___;
